import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setCompensationSettings, setEmploymentSettings, setInstitutionSettings, setMapPortalSettings, setMidYearSettings, setPersonSearchSettings, setSearchSettings } from '../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../root/tcsm-model';

export function useArcSettings(compensationSettingsId: string,
	employmentSettingsId: string,
	institutionSettingsId: string,
	searchSettingsId: string,
	personSearchSettingsId: string,
	midYearSettingsId: string,
	mapPortalSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.compensationSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, compensationSettingsId, { guid }, language, false, setCompensationSettings));
		}
		if (!epiApiState?.employmentSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, employmentSettingsId, { guid }, language, false, setEmploymentSettings));
		}
		if (!epiApiState?.institutionSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, institutionSettingsId, { guid }, language, false, setInstitutionSettings));
		}
		if (!epiApiState?.searchSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, searchSettingsId, { guid }, language, false, setSearchSettings));
		}

		if (!epiApiState?.personSearchSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, personSearchSettingsId, { guid }, language, false, setPersonSearchSettings));
		}

		if (!epiApiState?.midYearSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, midYearSettingsId, { guid }, language, false, setMidYearSettings));
		}

		if (!epiApiState?.mapPortalSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, mapPortalSettingsId, { guid }, language, false, setMapPortalSettings));
		}
	}, []);

	return epiApiState?.compensationSettingsState?.contentLoaded
		&& epiApiState?.employmentSettingsState?.contentLoaded
		&& epiApiState?.institutionSettingsState?.contentLoaded
		&& epiApiState?.searchSettingsState?.contentLoaded
		&& epiApiState?.personSearchSettingsState?.contentLoaded
		&& epiApiState?.midYearSettingsState?.contentLoaded
		&& epiApiState?.mapPortalSettingsState?.contentLoaded;
}